import { HTMLAttributes } from 'react';
import classNames from 'classnames';

import './like.scss';

import Typography from '../typography/Typography';
import { ThumbsUpIcon } from '../common.icons';
import { colors } from 'src/constants';

export type TLike = {
  count: number;
  onLike: () => void;
  onUnLike: () => void;
  active?: boolean;
  loading?: boolean;
} & HTMLAttributes<HTMLDivElement>;

const Like = ({ count = 0, onLike, onUnLike, className, active = false, loading = false, ...rest }: TLike) => {
  const handleClick = () => {
    if (loading) return
    if (active) {
      onUnLike();
    } else {
      onLike();
    }
  };

  return (
    <div
      className={classNames('like-component', className, { 'like-component--is-active': active })}
      {...rest}
      onClick={handleClick}
    >
      <Typography as="span" variant="body-1" fontWeight="medium">
        <ThumbsUpIcon opacity={loading ? 0.5 : 1} />
        {count !== 0 && <span>{count}</span>}
      </Typography>
    </div>
  );
};

export default Like;
